import axios from "axios";
import authHeader from "./auth-header";

const API_URL = `${process.env.REACT_APP_SERVER_URL}/sale-type`;

export const getActiveSaleTypes = () => {
  return axios.get(API_URL + "/actives", { headers: authHeader() });
};
